exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".non-padded {\r\n    margin-bottom: 0%;\r\n}\r\n\r\n.position-switcher {\r\n    margin-top: 10px;\r\n}\r\n\r\n.permission-name {\r\n    vertical-align: middle;\r\n}\r\n\r\n.left-aligned {\r\n    padding-left: 0;\r\n}\r\n\r\n.left-padded {\r\n    padding-left: 3%;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n    .position-switcher {\r\n        margin-top: auto;\r\n    }\r\n}\r\n         ", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/css-loader!F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/accessManagement/access-management.component.css
 ** module id = 949
 ** module chunks = 2
 **/